import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogHelper, HttpHelper } from 'nglhelper';
import { AuthService } from '../../common/services/authservice';
import { Version } from '../../appvariables';
import * as moment from 'moment';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent {

    constructor(private router: Router, private http: HttpHelper, private dialog: DialogHelper, private auth: AuthService) {

    }
    currentTime = new Date();
    version = Version;
    isRecover = false;
    errorMessage = '';
    trident: any = navigator.userAgent.match(/Trident\/(\d+)/);
    isIE = false;

    ngOnInit() {
        const trident = navigator.userAgent.match(/Trident\/(\d+)/);
        const tridentVersion = trident ? parseInt(trident[1], 10) : null;
        this.isIE = !(!trident || tridentVersion < 6);
    }

    async login(sitename, username, password) {
        try {
            var result = await this.http.Post("/api/account/Login", {
                Site: sitename,
                Username: username,
                Password: password
            });

            this.auth.Login(result);

            if(result.IsSysadmin)
                this.router.navigateByUrl('/sysadmin/site/list');
            else
                this.router.navigateByUrl("/sitemap");
        }
        catch (err) {

            if (err.message && err.message == 'Account already active on another window/machine.') {
                if (await this.dialog.Confirm(err.message + " Are you sure to login here? (Any unsave changes will be discard on other window)", "Active window here?")) {
                    this.login(sitename, username, password);
                }
            }
            else
                this.dialog.AlertError(err);
        }
    }

    // temporary not  in used
    async recoverpassword(username) {
        try {
            var res = await this.http.Post("/api/account/recover", {
                Username: username
            });

            this.dialog.AlertSuccess("A temporary password has been sent to " + res.Email + ".");
            this.isRecover = false;
        }
        catch (err) {
            this.dialog.AlertError(err);
        }
    }
}